export const MainHubRoute = "realTime";

export class HubClientMethods {
    // QuickBooks
    public static readonly SendQuickBooksState = "SendQuickBooksState";
    // Order
    public static readonly SyncOrder = "SyncOrder";
    public static readonly SyncOrders = "SyncOrders";
    // Shipment
    public static readonly SyncShipment = "SyncShipment";
    // FBA Shipment
    public static readonly SendFbaServiceNotification = "SendFbaServiceNotification";
    // To fetch USPS shipping account available balance
    public static readonly SendUspsAccountBalanceNotification = "SendUspsAccountBalanceNotification";
}

export interface HubInfo {
    readonly hubName?: string;
    readonly methodName: string;
}

export class StreamHubInfos {
    public static readonly RequestRates = new class implements HubInfo {
        public readonly methodName = "RequestRates";
    };

    public static readonly RequestQuickShipRates = new class implements HubInfo {
        public readonly methodName = "RequestQuickShipRates";
    };

    public static readonly PurchaseLabels = new class implements HubInfo {
        public readonly methodName = "PurchaseLabels";
    };

    public static readonly SearchOrderAddresses = new class implements HubInfo {
        public readonly methodName = "SearchOrderAddresses";
    };

    public static readonly SendFbaServiceNotification = new class implements HubInfo {
        public readonly methodName = "SendFbaServiceNotification";
    };
}
